export const STORAGE_KEYS = {
  // Auth related
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_INFO: 'user_info',
  
  // App settings
  THEME: 'app_theme',
  LANGUAGE: 'app_language',
  
  // Cache
  REACT_QUERY_CACHE: 'react_query_cache',
} as const

export const STORAGE_CONFIG = {
  // localStorage vs sessionStorage 전략
  PERSISTENT_KEYS: [
    STORAGE_KEYS.THEME,
    STORAGE_KEYS.LANGUAGE,
    STORAGE_KEYS.REACT_QUERY_CACHE,
  ],
  
  SESSION_KEYS: [
    STORAGE_KEYS.ACCESS_TOKEN,
    STORAGE_KEYS.REFRESH_TOKEN,
    STORAGE_KEYS.USER_INFO,
  ],
} as const
